import {makeAutoObservable} from "mobx"
import {api, catchApi} from "../../api"
import {pageLoadingStore} from "../PageLoadingStore"
import {UserListItemDto} from "../../api/ums";

class UserListStore {
    get createUserAvailable(): boolean {
        return this._createUserAvailable;
    }

    private set createUserAvailable(value: boolean) {
        this._createUserAvailable = value;
    }

    get page(): number {
        return this._page
    }

    set page(value: number) {
        this._page = value
    }

    get size(): number {
        return this._size
    }

    set size(value: number) {
        this._size = value
    }

    get pages(): number {
        return this._pages
    }

    set pages(value: number) {
        this._pages = value
    }

    get items(): UserListItemDto[] {
        return this._items
    }

    set items(value: UserListItemDto[]) {
        this._items = value
    }

    private _createUserAvailable = false
    private _items: UserListItemDto[] = []
    private _pages: number = 0
    private _page: number = 1
    private _size: number = 25

    constructor() {
        makeAutoObservable(this)
    }

    async checkCreateUserAvailable() {
        this.createUserAvailable = false
        const result = await catchApi(async () => api.ums.api.createUserAvailable())
        this.createUserAvailable = result?.data.isCreateUserAvailable || false
    }

    async load() {
        pageLoadingStore.loading = true
        const result = await catchApi(async () => await api.ums.api.listUsers({
            page: this.page - 1,
            size: this.size
        }))
        const data = result?.data
        if (data?.items) {
            this.items = data.items
            this.pages = data.totalPages || 0
        } else {
            this.items = []
            this.pages = 0
        }
        pageLoadingStore.loading = false
    }
}

const userListStore = new UserListStore()

export {
    userListStore
}
